module.exports = __webpack_public_path__ + "static/media/maxParties_1000.722d6aa9.png";